<template>
  <v-overlay :value="overlay">
    <OnboardingTop
      v-if="position === 'Top'"
      :overlay="overlay"
      @click="onClick($event)"
    />

    <OnboardingManager
      v-if="position === 'Manager'"
      :overlay="overlay"
      @click="onClick($event)"
    />

    <OnboardingSenior
      v-if="position === 'Senior'"
      :overlay="overlay"
      @click="onClick($event)"
    />

    <OnboardingJunior
      v-if="position === 'Junior'"
      :overlay="overlay"
      @click="onClick($event)"
    />

    <OnboardingEntry
      v-if="position === 'Entry'"
      :overlay="overlay"
      @click="onClick($event)"
    />
  </v-overlay>
</template>

<script>
import OnboardingTop from '@/components/pages/Common/OnboardingTop.vue';
import OnboardingManager from '@/components/pages/Common/OnboardingManager.vue';
import OnboardingSenior from '@/components/pages/Common/OnboardingSenior.vue';
import OnboardingJunior from '@/components/pages/Common/OnboardingJunior.vue';
import OnboardingEntry from '@/components/pages/Common/OnboardingEntry.vue';

export default {
  name: 'Onboarding',

  components: {
    OnboardingTop,
    OnboardingManager,
    OnboardingSenior,
    OnboardingJunior,
    OnboardingEntry,
  },

  props: {
    overlay: {
      type: Boolean,
      required: true,
    },
    position: {
      type: String,
      required: true,
    },
  },

  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>
